export default "__VITE_ASSET__9UmPOyYe__"